(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-floating-bundle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-rb-floating-bundle]';
    const registryKey = Symbol.for('rb-floating-bundle-registry');
    const registry = window[registryKey] || (window[registryKey] = { initialized: new WeakSet(), listening: false });

    const init = (root) => {
      if (!root || registry.initialized.has(root)) return;
      registry.initialized.add(root);

      const card = root.querySelector('[data-bundle-card]');
      const pill = root.querySelector('[data-expand]');
      const collapseButton = root.querySelector('[data-collapse]');
      const dragHandle = root.querySelector('[data-drag-handle]');
      const addButton = root.querySelector('[data-add-to-cart]');
      const status = root.querySelector('[data-status]');
      const sessionKey = root.dataset.sessionKey;
      let frame = 0;
      let dragStart = 0;
      let dragDistance = 0;
      let dragging = false;
      let shown = false;
      const isTwoProductsBundle = root.dataset.bundleMode === 'two_products';
      const recommendedProductNode = root.querySelector('[data-recommended-product-json]');
      const originalPrice = root.querySelector('[data-original-price]');
      const bundlePrice = root.querySelector('[data-bundle-price]');
      const variantOptions = [...root.querySelectorAll('[data-recommended-option]')];
      const parseProduct = (node) => {
        if (!node) return null;
        try { return JSON.parse(node.textContent); } catch (error) { return null; }
      };
      const getMainProductReferences = () => {
        const form = document.querySelector('#main-content .product.js-product .js-product-form-main');
        const container = form ? form.closest('.product.js-product') : null;
        const picker = container ? container.querySelector('variant-picker') : null;
        const pickerData = picker ? parseProduct(picker.querySelector('[type="application/json"]')) : null;
        return { form, product: pickerData ? pickerData.product : null };
      };
      let mainProductReferences = getMainProductReferences();
      let mainProductForm = mainProductReferences.form;
      let currentProduct = mainProductReferences.product;
      const recommendedProduct = parseProduct(recommendedProductNode);
      const variantById = (product, id) => product && product.variants ? product.variants.find((variant) => String(variant.id) === String(id)) : null;
      let currentVariant = variantById(currentProduct, mainProductForm ? mainProductForm.querySelector('input[name="id"]')?.value : root.dataset.currentVariantId);
      let recommendedVariant = variantById(recommendedProduct, root.dataset.recommendedVariantId);
      let selectedRecommendedOptions = recommendedVariant && recommendedVariant.options ? [...recommendedVariant.options] : [];

      const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
      const isStickyAtcMobile = () => window.matchMedia('(max-width: 768.98px)').matches;
      const isEnabledForViewport = () => isMobile() ? root.dataset.mobileEnabled === 'true' : root.dataset.desktopEnabled === 'true';
      const setStatus = (message, type) => {
        status.textContent = message || '';
        status.classList.remove('is-error', 'is-success');
        if (type) status.classList.add(`is-${type}`);
      };
      const formatPrice = (amount) => {
        const format = window.theme && window.theme.settings ? window.theme.settings.moneyWithCurrencyFormat : null;
        const placeholder = format && format.match(/\{\{\s*(\w+)\s*\}\}/);
        if (placeholder) {
          const formatWithDelimiters = (number, precision, thousands, decimal) => {
            const value = (Number(number) / 100).toFixed(precision);
            const parts = value.split('.');
            return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`) + (precision ? decimal + parts[1] : '');
          };
          const formats = {
            amount: [2, ',', '.'],
            amount_no_decimals: [0, ',', '.'],
            amount_with_comma_separator: [2, '.', ','],
            amount_no_decimals_with_comma_separator: [0, '.', ','],
            amount_with_apostrophe_separator: [2, "'", '.']
          };
          const settings = formats[placeholder[1]] || formats.amount;
          return format.replace(placeholder[0], formatWithDelimiters(Math.round(amount), settings[0], settings[1], settings[2]));
        }
        const currency = root.dataset.currencyCode || 'EUR';
        return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency }).format(Number(amount) / 100);
      };
      const getCurrentVariantInput = () => mainProductForm ? mainProductForm.querySelector('input[name="id"]') : null;
      const syncCurrentVariant = () => {
        const input = getCurrentVariantInput();
        if (input && currentProduct) {
          const nextVariant = variantById(currentProduct, input.value);
          if (nextVariant) currentVariant = nextVariant;
        }
      };
      const refreshMainProductReferences = () => {
        mainProductReferences = getMainProductReferences();
        mainProductForm = mainProductReferences.form;
        currentProduct = mainProductReferences.product;
        syncCurrentVariant();
      };
      let stickyAtcElement = null;
      let stickyAtcObserver = null;
      let stickyAtcResizeObserver = null;
      let stickyAtcBodyObserver = null;
      let stickyAtcFrame = 0;
      const updateStickyAtcOffset = () => {
        if (!stickyAtcElement || !isStickyAtcMobile()) {
          root.classList.remove('is-sticky-atc-visible');
          root.style.removeProperty('--rb-sticky-atc-height');
          return;
        }
        const stickyAtcStyle = window.getComputedStyle(stickyAtcElement);
        const stickyAtcRect = stickyAtcElement.getBoundingClientRect();
        const stickyAtcHeight = stickyAtcRect.height;
        const stickyAtcBottomGap = Math.max(0, window.innerHeight - stickyAtcRect.bottom);
        const isVisible = !document.body.classList.contains('scrolled-to-bottom') && !stickyAtcElement.classList.contains('sticky-atc-panel--out') && stickyAtcStyle.visibility !== 'hidden' && stickyAtcStyle.display !== 'none' && stickyAtcHeight > 0;
        root.classList.toggle('is-sticky-atc-visible', isVisible);
        if (isVisible) root.style.setProperty('--rb-sticky-atc-height', `${stickyAtcHeight + stickyAtcBottomGap}px`);
        else root.style.removeProperty('--rb-sticky-atc-height');
      };
      const scheduleStickyAtcOffset = () => {
        if (stickyAtcFrame) return;
        stickyAtcFrame = window.requestAnimationFrame(() => {
          stickyAtcFrame = 0;
          updateStickyAtcOffset();
        });
      };
      const bindStickyAtcAvoidance = () => {
        if (stickyAtcObserver) stickyAtcObserver.disconnect();
        if (stickyAtcResizeObserver) stickyAtcResizeObserver.disconnect();
        if (stickyAtcBodyObserver) stickyAtcBodyObserver.disconnect();
        stickyAtcElement = document.querySelector('#main-content sticky-atc-panel.sticky-atc-panel');
        if (stickyAtcElement && 'MutationObserver' in window) {
          stickyAtcObserver = new MutationObserver(scheduleStickyAtcOffset);
          stickyAtcObserver.observe(stickyAtcElement, { attributes: true, attributeFilter: ['class', 'style'] });
          stickyAtcBodyObserver = new MutationObserver(scheduleStickyAtcOffset);
          stickyAtcBodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        }
        if (stickyAtcElement && 'ResizeObserver' in window) {
          stickyAtcResizeObserver = new ResizeObserver(scheduleStickyAtcOffset);
          stickyAtcResizeObserver.observe(stickyAtcElement);
        }
        scheduleStickyAtcOffset();
      };
      const updateRecommendedSelector = () => {
        if (!recommendedProduct || !recommendedProduct.variants) return;
        variantOptions.forEach((option) => {
          const index = Number(option.closest('[data-option-index]').dataset.optionIndex);
          const value = option.dataset.optionValue;
          const available = recommendedProduct.variants.some((variant) => variant.available && variant.options.every((variantValue, variantIndex) => variantIndex === index ? variantValue === value : variantValue === selectedRecommendedOptions[variantIndex]));
          option.disabled = !available;
          option.setAttribute('aria-pressed', String(selectedRecommendedOptions[index] === value));
        });
      };
      const updateTwoProductsState = () => {
        if (!isTwoProductsBundle || !addButton) return;
        syncCurrentVariant();
        const available = Boolean(currentVariant && currentVariant.available && recommendedVariant && recommendedVariant.available);
        addButton.disabled = !available;
        if (!available) setStatus(root.dataset.unavailableMessage, 'error');
        else if (status.textContent === root.dataset.unavailableMessage) setStatus('');
        if (currentVariant && recommendedVariant && originalPrice && bundlePrice) {
          const combinedPrice = Number(currentVariant.price) + Number(recommendedVariant.price);
          const discountedPrice = combinedPrice - (combinedPrice * Number(root.dataset.discountPercentage || 0) / 100);
          originalPrice.textContent = formatPrice(combinedPrice);
          bundlePrice.textContent = formatPrice(discountedPrice);
        }
      };
      const chooseRecommendedVariant = (event) => {
        const option = event.currentTarget;
        if (option.disabled || !recommendedProduct) return;
        const index = Number(option.closest('[data-option-index]').dataset.optionIndex);
        selectedRecommendedOptions[index] = option.dataset.optionValue;
        let matchingVariant = recommendedProduct.variants.find((variant) => variant.options.every((value, optionIndex) => value === selectedRecommendedOptions[optionIndex]) && variant.available);
        if (!matchingVariant) {
          matchingVariant = recommendedProduct.variants.find((variant) => variant.available && variant.options[index] === selectedRecommendedOptions[index]);
          if (matchingVariant) selectedRecommendedOptions = [...matchingVariant.options];
        }
        if (matchingVariant) recommendedVariant = matchingVariant;
        updateRecommendedSelector();
        updateTwoProductsState();
      };
      const canUseStorage = () => {
        try { return window.sessionStorage !== null; } catch (error) { return false; }
      };
      const wasCollapsed = () => canUseStorage() && window.sessionStorage.getItem(sessionKey) === 'true';
      const rememberCollapsed = (value) => {
        if (!canUseStorage()) return;
        if (value) window.sessionStorage.setItem(sessionKey, 'true');
        else window.sessionStorage.removeItem(sessionKey);
      };
      const resetDragStyle = () => {
        card.style.removeProperty('transform');
        card.style.removeProperty('opacity');
      };
      const open = (manual) => {
        if (!isEnabledForViewport()) return;
        if (manual) rememberCollapsed(false);
        root.classList.remove('is-collapsed');
        root.classList.add('is-open');
        card.setAttribute('aria-hidden', 'false');
        pill.setAttribute('aria-hidden', 'true');
        pill.tabIndex = -1;
        shown = true;
      };
      const collapse = () => {
        cancelAnimationFrame(frame);
        root.classList.remove('is-open', 'is-dragging');
        root.classList.add('is-collapsed');
        resetDragStyle();
        card.setAttribute('aria-hidden', 'true');
        pill.setAttribute('aria-hidden', 'false');
        pill.tabIndex = 0;
        rememberCollapsed(true);
      };
      const hideForViewport = () => {
        root.classList.remove('is-open', 'is-collapsed');
        card.setAttribute('aria-hidden', 'true');
        pill.setAttribute('aria-hidden', 'true');
        pill.tabIndex = -1;
      };
      const showFromTrigger = () => {
        if (shown || !isEnabledForViewport() || wasCollapsed()) return;
        open(false);
      };
      const setDragVisual = () => {
        const distance = Math.max(0, dragDistance);
        card.style.transform = `translate3d(0, ${distance}px, 0)`;
        card.style.opacity = String(Math.max(.55, 1 - distance / 280));
        frame = 0;
      };
      const onPointerDown = (event) => {
        if (root.dataset.enableDrag !== 'true' || event.button && event.button !== 0) return;
        dragging = true;
        dragStart = event.clientY;
        dragDistance = 0;
        root.classList.add('is-dragging');
        dragHandle.setPointerCapture(event.pointerId);
      };
      const onPointerMove = (event) => {
        if (!dragging) return;
        const delta = event.clientY - dragStart;
        dragDistance = delta > 0 ? delta : Math.max(delta * .18, -12);
        if (!frame) frame = requestAnimationFrame(setDragVisual);
      };
      const onPointerEnd = (event) => {
        if (!dragging) return;
        dragging = false;
        if (dragHandle.hasPointerCapture(event.pointerId)) dragHandle.releasePointerCapture(event.pointerId);
        root.classList.remove('is-dragging');
        if (dragDistance >= 80) collapse();
        else resetDragStyle();
      };
      const scheduleTrigger = () => {
        if (root.dataset.designMode === 'true') { open(false); return; }
        if (wasCollapsed()) { collapse(); return; }
        if (root.dataset.trigger === 'scroll') {
          const onScroll = () => {
            const height = document.documentElement.scrollHeight - window.innerHeight;
            const progress = height > 0 ? (window.scrollY / height) * 100 : 0;
            if (progress >= Number(root.dataset.scrollPercent || 0)) { showFromTrigger(); window.removeEventListener('scroll', onScroll); }
          };
          window.addEventListener('scroll', onScroll, { passive: true });
          onScroll();
          return;
        }
        if (root.dataset.trigger === 'atc') {
          const addToCartArea = document.querySelector('#main-content .product.js-product .js-product-form-main');
          if (addToCartArea && 'IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries) => {
              if (entries.some((entry) => entry.isIntersecting)) { showFromTrigger(); observer.disconnect(); }
            }, { threshold: .15 });
            observer.observe(addToCartArea);
          }
          return;
        }
        window.setTimeout(showFromTrigger, Number(root.dataset.showDelay || 3000));
      };
      const addToCart = async () => {
        if (root.classList.contains('is-loading')) return;
        let items = [];
        if (isTwoProductsBundle) {
          syncCurrentVariant();
          updateTwoProductsState();
          if (!currentVariant || !currentVariant.available || !recommendedVariant || !recommendedVariant.available) return;
          const properties = {
            _rb_bundle: root.dataset.bundleLabel,
            _rb_bundle_source: root.dataset.bundleSource
          };
          items = [
            { id: Number(currentVariant.id), quantity: 1, properties },
            { id: Number(recommendedVariant.id), quantity: 1, properties }
          ];
        } else {
          const variantId = root.dataset.variantId;
          if (!variantId) return;
          items = [{ id: Number(variantId), quantity: 1 }];
        }
        root.classList.add('is-loading');
        addButton.disabled = true;
        setStatus('');
        try {
          // Two-product prices shown in this Section are informational; Shopify Discounts, Functions, or Bundles must apply the real checkout discount.
          const cartDrawer = document.querySelector('cart-drawer');
          const canRenderCartDrawer = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function' && typeof cartDrawer.renderContents === 'function';
          const payload = { items };
          if (canRenderCartDrawer) {
            payload.sections = cartDrawer.getSectionsToRender().map((section) => section.section).join(',');
            payload.sections_url = window.location.pathname;
          }
          const themeCartAddUrl = window.theme && window.theme.routes ? window.theme.routes.cartAdd : '/cart/add';
          const cartAddUrl = themeCartAddUrl.endsWith('.js') ? themeCartAddUrl : `${themeCartAddUrl}.js`;
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(payload)
          });
          if (!response.ok) throw new Error('cart_add_failed');
          const data = await response.json();
          setStatus(root.dataset.successMessage, 'success');
          if (canRenderCartDrawer) {
            await cartDrawer.renderContents(data, true);
            return;
          }
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          setStatus(root.dataset.errorMessage, 'error');
          addButton.disabled = false;
        } finally {
          root.classList.remove('is-loading');
        }
      };

      collapseButton.addEventListener('click', collapse);
      pill.addEventListener('click', () => open(true));
      if (dragHandle) {
        dragHandle.addEventListener('pointerdown', onPointerDown);
        dragHandle.addEventListener('pointermove', onPointerMove);
        dragHandle.addEventListener('pointerup', onPointerEnd);
        dragHandle.addEventListener('pointercancel', onPointerEnd);
      }
      if (addButton) addButton.addEventListener('click', addToCart);
      let boundCurrentVariantInput = null;
      const onCurrentVariantInputChange = () => updateTwoProductsState();
      const bindCurrentVariantInput = () => {
        if (boundCurrentVariantInput) {
          boundCurrentVariantInput.removeEventListener('change', onCurrentVariantInputChange);
          boundCurrentVariantInput.removeEventListener('input', onCurrentVariantInputChange);
        }
        boundCurrentVariantInput = getCurrentVariantInput();
        if (boundCurrentVariantInput) {
          boundCurrentVariantInput.addEventListener('change', onCurrentVariantInputChange);
          boundCurrentVariantInput.addEventListener('input', onCurrentVariantInputChange);
        }
      };
      const onThemeVariantChange = (event) => {
        if (!isTwoProductsBundle || !event.detail || event.detail.form !== mainProductForm || !event.detail.product || String(event.detail.product.id) !== root.dataset.currentProductId) return;
        currentVariant = event.detail.variant;
        updateTwoProductsState();
      };
      if (isTwoProductsBundle) {
        variantOptions.forEach((option) => option.addEventListener('click', chooseRecommendedVariant));
        bindCurrentVariantInput();
        document.addEventListener('on:variant:change', onThemeVariantChange);
        updateRecommendedSelector();
        updateTwoProductsState();
      }
      const isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
      const onThemeEditorMainProductLoad = (event) => {
        if (!isThemeEditor || !event.target.querySelector('.js-product-form-main')) return;
        window.requestAnimationFrame(() => {
          refreshMainProductReferences();
          if (isTwoProductsBundle) {
            bindCurrentVariantInput();
            updateTwoProductsState();
          }
          bindStickyAtcAvoidance();
        });
      };
      const onThemeEditorMainProductUnload = (event) => {
        if (!isThemeEditor || !mainProductForm || !event.target.contains(mainProductForm)) return;
        mainProductForm = null;
        currentProduct = null;
        currentVariant = null;
        if (isTwoProductsBundle) updateTwoProductsState();
      };
      const onResize = () => {
        if (!isEnabledForViewport()) hideForViewport();
        else if (wasCollapsed()) collapse();
        else if (shown) open(false);
        scheduleStickyAtcOffset();
      };
      const onSectionUnload = (event) => {
        if (event.target !== root && !event.target.contains(root)) return;
        window.removeEventListener('resize', onResize);
        if (isTwoProductsBundle) document.removeEventListener('on:variant:change', onThemeVariantChange);
        if (boundCurrentVariantInput) {
          boundCurrentVariantInput.removeEventListener('change', onCurrentVariantInputChange);
          boundCurrentVariantInput.removeEventListener('input', onCurrentVariantInputChange);
        }
        if (stickyAtcObserver) stickyAtcObserver.disconnect();
        if (stickyAtcResizeObserver) stickyAtcResizeObserver.disconnect();
        if (stickyAtcBodyObserver) stickyAtcBodyObserver.disconnect();
        if (stickyAtcFrame) window.cancelAnimationFrame(stickyAtcFrame);
        if (isThemeEditor) {
          document.removeEventListener('shopify:section:load', onThemeEditorMainProductLoad);
          document.removeEventListener('shopify:section:unload', onThemeEditorMainProductUnload);
        }
        document.removeEventListener('shopify:section:unload', onSectionUnload);
      };
      window.addEventListener('resize', onResize, { passive: true });
      document.addEventListener('shopify:section:unload', onSectionUnload);
      if (isThemeEditor) {
        document.addEventListener('shopify:section:load', onThemeEditorMainProductLoad);
        document.addEventListener('shopify:section:unload', onThemeEditorMainProductUnload);
      }
      bindStickyAtcAvoidance();
      scheduleTrigger();
    };

    const initializeAll = (scope) => (scope || document).querySelectorAll(selector).forEach(init);
    initializeAll();
    if (!registry.listening) {
      registry.listening = true;
      document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
